import { Strategy } from '@floating-ui/react'
import {
  cn,
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger
} from 'design-system'
import { CircleHelp, LucideIcon } from 'lucide-react'
import React, { FC, PropsWithChildren } from 'react'

type InfoTooltipProps = {
  Icon?: LucideIcon
  className?: string
  iconSize?: number
  strategy?: Strategy
  /** Provide a descriptive, unique label so screen readers can distinguish tooltips on the same page */
  label?: string
  tabIndex?: number
}

export const InfoTooltip: FC<PropsWithChildren<InfoTooltipProps>> = ({
  Icon = CircleHelp,
  iconSize = 16,
  children,
  className,
  strategy = 'absolute',
  label = 'Show more information',
  tabIndex
}) => {
  return (
    <Tooltip strategy={strategy} persistOnHover>
      <TooltipTrigger
        aria-label={label}
        tabIndex={tabIndex}
        onClick={e => {
          e.preventDefault()
        }}
        className={cn('shrink-0 cursor-pointer text-blue-600', className)}>
        <Icon size={iconSize} aria-hidden className="block" />
      </TooltipTrigger>
      <TooltipContent className="font-light">
        <TooltipArrow />
        <div className="max-h-72 max-w-72 overflow-y-auto">{children}</div>
      </TooltipContent>
    </Tooltip>
  )
}
